import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  BoxV2,
  ButtonV2,
  LabraToolTipV2,
  TextArea,
} from '@labrav/react-components'
import React, { useState } from 'react'
import { faMoneyCheckDollar } from '@fortawesome/pro-regular-svg-icons'
import { Typography } from '@mui/material'
import { useStyles } from './FlyOutProductRefundPolicy.styles'
import { FormikProps, useFormikContext } from 'formik'
import { RequirementLink } from '../../../types/RequirementLink'
import { FormLockedType } from '../../../types/FormLockedType'
import { FlyoutProductSections } from '../../../types/addEditProduct'
import { FlyoutProductDetailsRefundPolicyFaqs } from './FlyoutProductDetailsRefundPolicyFaqs'

type FlyOutProductRefundPolicyProps = {
  handleRefLinkClick?: (inex: number) => void
  detailView?: boolean
  detailViewTooltip?: string
}

export const FlyOutProductRefundPolicy: React.FC<
  RequirementLink & FormLockedType & FlyOutProductRefundPolicyProps
> = ({ isFormLocked, handleRefLinkClick, detailView, detailViewTooltip }) => {
  const { classes } = useStyles()
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext() as FormikProps<FlyoutProductSections>

  const generalInformation = values.generalInformation
  const generalInformationErrors = errors.generalInformation
  const generalInformationTouched = touched.generalInformation
  const [indexModal, setIndexModal] = useState<number>(1)

  return (
    <BoxV2
      heading={'Specify refund policy'}
      headingIcon={
        <FontAwesomeIcon
          icon={faMoneyCheckDollar}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={
        <FlyoutProductDetailsRefundPolicyFaqs
          indexModal={indexModal}
          setIndexModal={setIndexModal}
        />
      }
    >
      <div className={classes.sectionContainer}>
        <div className={classes.textContainer}>
          <div className={classes.sectionHeadingContainer}>
            {' '}
            <Typography className={classes.sectionHeading}>
              Refund policy
            </Typography>
          </div>
          <Typography className={classes.sectionText}>
            All paid products listed on AWS Marketplace must have a stated
            refund policy. The refund policy for your product must include the
            terms of the policy and must provide buyers with a means of
            contacting you to request a refund. This information is visible to
            buyers on the product listing page. (up to 500 characters max).
            <ButtonV2
              styleType="link"
              onClick={() => handleRefLinkClick && handleRefLinkClick(1)}
            >
              (Refer no. 8 in image no. 2)
            </ButtonV2>
          </Typography>
        </div>
        <LabraToolTipV2
          tooltipPlacement="bottom-start"
          description={detailViewTooltip}
          followCursor={detailView}
          className={classes.fullWidth}
        >
          <TextArea
            keyName="generalInformation.refundPolicy"
            title="Enter refund policy"
            rows={1}
            maxCharacters={500}
            height={80}
            type="string"
            placeHolder=""
            value={generalInformation.refundPolicy}
            updatedValue={generalInformation.refundPolicy}
            isError={
              !!(
                generalInformationTouched?.refundPolicy &&
                generalInformationErrors?.refundPolicy
              )
            }
            onChange={handleChange}
            isReadOnly={isFormLocked as boolean}
            isRequired={false}
            errorText={
              (!!generalInformationTouched?.refundPolicy &&
                generalInformationErrors?.refundPolicy) ||
              ''
            }
            showSpinner={false}
            onBlur={handleBlur}
            viewOnly={detailView}
          />
        </LabraToolTipV2>
      </div>
    </BoxV2>
  )
}
